import { PaginationResponse } from 'models/pagination'

import { ISupervisor } from '../../models/supervisor'
import { PaginationParams } from './../../models/pagination'
import { clientApi } from './clientApi'

export interface SupervisorsParams extends PaginationParams {
  region?: string
}

export interface SwapSupervisorsDTO {
  old_supervisor: string
  new_supervisor: string
}

export const SupervisorsApi = {
  getSupervisors(params: SupervisorsParams) {
    return clientApi.get<PaginationResponse<ISupervisor>>('/web/supervisors/', {
      params,
    })
  },
  swapSupervisors(body: SwapSupervisorsDTO) {
    return clientApi.post<{ message: string }>('/users/swap_consultants/', body)
  },
}
